import { type z } from "zod"

import { createPackagingInfoSchema } from "../PackagingInfo"

import { useFreightClass } from "./useFreightClass"

import { parseProductFreights } from "@/screens/Products/utils"

export const usePackagingInfoSchema = (): z.ZodSchema => {
  const { data } = useFreightClass()

  const parsedProductFreights = parseProductFreights(data)

  return createPackagingInfoSchema(parsedProductFreights)
}
